import { useNavigate } from 'react-router-dom'
import { Auth0LoginButton } from 'grabbitbot-legacy-ui'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, POST_LOGIN_PATH } from '../../config'

// Equivalent of legacy `UserPasswordForgotComponent`. 2026-09-26 (owner
// decision, legacy-migration/RULES.md): password reset moved to Auth0's own
// Universal Login "Forgot password?" link — this route stays registered
// (bookmarked links must not 404) but just points at sign-in.
export function PasswordForgotPage() {
  const navigate = useNavigate()
  return (
    <div className="screener-card screener-card--auth">
      <h1>Reset your password</h1>
      <p>
        Password reset now happens as part of signing in — click below, then
        use the "Forgot password?" link on the sign-in screen.
      </p>
      <Auth0LoginButton
        popupUrl={AUTH0_LOGIN_URL}
        expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
        onSuccess={() => navigate(POST_LOGIN_PATH, { replace: true })}
      >
        Log in
      </Auth0LoginButton>
    </div>
  )
}
